<template>
  <div class="pop-payment-wrap">
    <div class="pop-header">
      <span class="pop-title">쿠폰</span>
      <button class="btn-pop-close" @click="$emit('close')">
        닫기<span class="overlay"></span>
      </button>
    </div>
    <div class="pop-body">
      <div class="fieldset admin-mt24">
        <div class="flex">
          <div class="fieldset-scroll xsm trans-scroll">
            <div class="fieldset-button-grid lg">
              <button
                type="button"
                class="btn-coupon"
                @click="activeCouponGroup = group.couponGroupIdx"
                v-for="group in couponGroupList"
                :key="group"
                :class="{
                  'coupon-selected': group.couponGroupIdx == activeCouponGroup,
                }"
              >
                {{ group.couponGroupName }}<span class="overlay"></span>
              </button>
            </div>
          </div>
          <div class="tb-side-btn">
            <button type="button" class="btn-side-up">
              위로<span class="overlay"></span>
            </button>
            <button type="button" class="btn-side-down">
              아래로<span class="overlay"></span>
            </button>
          </div>
        </div>
      </div>
      <div class="fieldset admin-mt24">
        <span class="h2">쿠폰정보</span>
        <div class="ip-row col04">
          <label for="memName">쿠폰명</label>
          <input
            type="text"
            class="ip-comm center"
            id="couponName"
            :value="couponName"
          />
          <label for="memNum">허용상품</label>
          <input
            type="text"
            class="ip-comm center"
            id="couponProd"
            :value="activeCoupon > 0 ? '전체' : ''"
          />
        </div>
        <div class="ip-row">
          <label for="payCardNum">할인구분</label>
          <input
            type="text"
            class="ip-comm center"
            id="descType"
            :value="couponDesc"
          />
        </div>
      </div>
      <div class="flex admin-mt24">
        <table class="tb-lst-payment tb-coupon-list">
          <thead>
            <tr>
              <td>No.</td>
              <td>쿠폰명</td>
              <td>할인구분</td>
              <td>매 수</td>
              <td>비 고</td>
            </tr>
          </thead>
          <tbody>
            <tr
              :key="coupon"
              @click="activeCoupon = coupon.couponDetailIdx"
              :class="{ on: activeCoupon == coupon.couponDetailIdx }"
              v-for="(coupon, i) in couponDetailList.filter(
                (item) => item.couponGroupIdx == activeCouponGroup
              )"
            >
              <td>{{ i + 1 }}</td>
              <td>{{ coupon.couponDetailName }}</td>
              <td>
                <span class="ellipsis"
                  >{{ coupon.amount
                  }}{{ coupon.discountType == "rate" ? "%" : "원" }}</span
                >
              </td>
              <td>{{ coupon.cnt }}</td>
              <td>-</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="service-btn-area admin-mt24 with-scroll-btn">
        <button class="admin-btn-up admin-mr0">
          <span class="overlay"></span>
        </button>
        <button class="admin-btn-down"><span class="overlay"></span></button>
        <button
          type="button"
          class="btn-pop btn-cancel admin-mb0"
          @click="$emit('close')"
        >
          취 소<span class="overlay"></span>
        </button>
        <button
          type="button"
          class="btn-pop btn-submit admin-mb0"
          @click="applyCoupon()"
        >
          사 용<span class="overlay"></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "coupon",
  props: {},
  data() {
    return {
      couponGroupList: this.$store.getters.getCouponGroupList,
      couponDetailList: this.$store.getters.getCouponDetailList,
      activeCoupon: -1,
      activeCouponGroup: -1,
    };
  },
  methods: {
    applyCoupon() {
      if (
        this.couponDetailList.filter(
          (item) => item.couponDetailIdx == this.activeCoupon
        ).length > 0
      ) {
        let coupon = this.couponDetailList.filter(
          (item) => item.couponDetailIdx == this.activeCoupon
        )[0];
        this.$emit("applyCoupon", coupon);
      } else return false;
    },
  },
  watch: {},
  computed: {
    couponName() {
      if (
        this.couponDetailList.filter(
          (item) => item.couponDetailIdx == this.activeCoupon
        ).length > 0
      ) {
        return this.couponDetailList.filter(
          (item) => item.couponDetailIdx == this.activeCoupon
        )[0].couponDetailName;
      } else return "";
    },
    couponDesc() {
      if (
        this.couponDetailList.filter(
          (item) => item.couponDetailIdx == this.activeCoupon
        ).length > 0
      ) {
        let coupon = this.couponDetailList.filter(
          (item) => item.couponDetailIdx == this.activeCoupon
        )[0];
        return coupon.amount + (coupon.discountType == "rate" ? "%" : "원");
      } else return "";
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  unmounted() {},
  components: {},
};
</script>

<style src="@/assets/css/style.css" scoped></style>
<style scoped></style>


